export const formFilter = [
    {
        input: {
            id: 'dataDe',
            label: 'Data de Acesso (De)',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: {
            id: 'dataAte',
            label: 'Data de Acesso (Até)',
            placeholder: 'dd/mm/aaaa',
            type: 'date'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    },
    {
        input: { id: 'nomeUsuario', label: 'Nome do Usuário', placeholder: 'Digite o nome' },
        layout: { type: 'col', layout: { base: 12, md: 3 } }
    },
    {
        input: { id: 'cpf', label: 'CPF', placeholder: '000.000.000-00', mask: 'cpf' },
        layout: { type: 'col', layout: { base: 12, md: 3 } }
    },
    {
        input: { id: 'email', label: 'E-mail', placeholder: 'Digite o e-mail' },
        layout: { type: 'col', layout: { base: 12, md: 3 } }
    },
    {
        select: {
            id: 'acessoPerfil',
            label: 'Perfil de Acesso',
            placeholder: 'Todos os perfis',
            options: [
                { text: 'Master', value: 'master' },
                { text: 'Operacional', value: 'operacional' }
            ]
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 3 }
        }
    }
];